// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"cc297f43","262":"65a92513","332":"cc297f43","502":"cc297f43","824":"cc297f43","872":"cc297f43","981":"495865fc"}[chunkId] + ".chunk.css";
};